import React from 'react';
import { ITableDataSource } from 'models/table';
import { Grid, Link, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { StyledTableCard, StyledTableCardItem, StyledTooltip } from '../../../styles';
import { Chips } from 'components/atoms/Chips';
import { renderLicenceDataColor } from 'components/molecules/Table/helpers';
import { ERouteLinks } from 'models/route';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';

interface ILicencesTableCard {
  data: ITableDataSource;
  caseId: string;
  setModalAssetsData: (data: any) => void;
}

export const LicencesTableCard = ({
  data,
  caseId,
  setModalAssetsData,
}: ILicencesTableCard) => {
  const { t } = useTranslations();
  return (
    <StyledTableCard container>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.licenceNumber)}</Typography>
        <Typography variant="body2">
          <Link
            href={ERouteLinks.CaseDetailLicencePage.replace(
              ':licenceId',
              data.id as string,
            ).replace(':caseId', caseId)}
            underline="none"
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.licenceNumber}
          </Link>
        </Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.licenceStatus)}</Typography>
        <Typography variant="body2">
          <Chips text={data.status} variant={renderLicenceDataColor(data)?.stateField} />
        </Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.startDate)}</Typography>
        <Typography variant="body2">{data.startDate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.endDate)}</Typography>
        <Typography variant="body2">{data.endDate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.assetId)}</Typography>
        {data.assets && data.assets.length && (
          <Grid container>
            {data.assets.length === 1 && (
              <Link
                href={ERouteLinks.ViewRegisteredFirearm.replace(
                  ':id',
                  data.assets[0].uniqueId,
                )}
                underline="none"
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.assets[0].fireCycleId}
              </Link>
            )}
            {data.assets.length > 1 && (
              <Link underline="none" style={{ cursor: 'pointer' }}>
                <div onClick={() => setModalAssetsData(data.assets)}>
                  {t('caseManagement.cases.displayAllAssets.label').replace(
                    '{0}',
                    data.assets.length,
                  )}
                </div>
              </Link>
            )}
          </Grid>
        )}
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.createDate)}</Typography>
        <Typography variant="body2">{data.createdDate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.createdBy)}</Typography>
        <Typography variant="body2">{data.createdBy}</Typography>
      </StyledTableCardItem>
    </StyledTableCard>
  );
};
